/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthEmailResponse } from '../models/AuthEmailResponse';
import type { PasswordResetEmailRequest } from '../models/PasswordResetEmailRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AuthEmailService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Request Verification Email
     * @returns AuthEmailResponse Successful Response
     * @throws ApiError
     */
    public requestVerificationEmailAuthEmailVerificationPost(): CancelablePromise<AuthEmailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/auth/email/verification',
        });
    }

    /**
     * Request Password Reset Email
     * @param requestBody
     * @returns AuthEmailResponse Successful Response
     * @throws ApiError
     */
    public requestPasswordResetEmailAuthEmailPasswordResetPost(
        requestBody: PasswordResetEmailRequest,
    ): CancelablePromise<AuthEmailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/auth/email/password-reset',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
